<div class="percent">
  <span *ngIf="!isNaN((results | async)?.value)" class="value">
    {{ ((results | async)?.value | number:'1.0-0') + '%' }}
  </span>
  <span *ngIf="isNaN((results | async)?.value)" class="no-data">
    {{ 'NO_DATA_SHORT' | translate }}
  </span>
  <div
    *ngIf="!isNaN((results | async)?.value) && !isNaN((results | async)?.valueYesterday)"
    class="indicator-wrapper"
    [class.up]="(results | async)?.value > (results | async)?.valueYesterday"
    [class.up-negative]="!increasePositiveSentiment"
    [class.down-positive]="!increasePositiveSentiment"
    [class.neutral]="(results | async)?.value === (results | async)?.valueYesterday"
  >
    <div class="indicator"></div>
  </div>
</div>
<div class="percent-yesterday">
  <div class="percent-text" translate>INBOUND_DASHBOARD.YESTERDAY</div>
  <div class="yesterday-value">
    {{ !isNaN((results | async)?.valueYesterday) ? ((results | async)?.valueYesterday | number:'1.0-0') + '%' : 'NO_DATA_SHORT' | translate }}
  </div>
</div>
